import React from "react";

export default class MissingPropertyError extends Error {
	constructor(args) {
		super(args);
		this.ui_message = this.message;
		// Error.captureStackTrace(this, MissingPropertyError);
	}
}